import { _http, _api, util } from '../libs'
import { config, system } from '../config'
import store from './index'
import router from '@/router'

store.registerModule('sysUser', {
  namespaced: true,
  state: {
    wxAutoReg: true,
    loginCheck: false,
    token: localStorage.getItem('pcSysToken'),
    userPromise: null,
    sysUser: {},
    menu: [],
    supervisors: [],
    isAdmin: false

  },
  mutations: {
    // 修改用户信息
    SET_USER_INFO(state, sysUser) {
      localStorage.setItem('pcSysToken', sysUser.token)
      sysUser.menuArrayJson = sysUser.menuArrayJson || []
      state.sysUser = sysUser
      state.token = sysUser.token
      state.loginCheck = true
      state.isAdmin = sysUser.menuArrayJson.indexOf('admin') > -1
      store.state.ivew.configPromise.then(payload => {
        state.menu = system.filter(sysUser, store.state.ivew.config.actOnJson || ['security'])
        if (!state.routers) {
          state.routers = config.createRouter({ menu: state.menu, pages: system.pages.pages, title: store.state.ivew.config.baseJson.title }, 'system')
        }
      })
    },

    // 注销用户
    SET_USER_LOGIN_OUT(state) {
      localStorage.removeItem('pcSysToken')
      state.sysUser = null
      state.token = null
      state.loginCheck = false
      router.push({ path: '/system/login' })
    },

    // 设置部门树
    SET_BRANCH_TREE(state, payload) {
      util.tree.filter([payload], item => Object.assign(item, { value: item.id, label: item.name }))
      state.supervisors = [payload]
    },

  },
  actions: {

    // 登录验证
    loginSysCheck(store, token) {
      return _http.get(_api.sys.sysUserMine.opData, { params: { token: token } }).then(res => store.commit('SET_USER_INFO', res))
    },

    // 使用用户名密码登陆
    loginSysRegName(store, param) {
      return _http.get(_api.sys.sysUserMine.opLoginPass, { params: param }).then(res => store.commit('SET_USER_INFO', res))
    },

    // 使用手机号验证码登陆
    loginSysSmsCode(store, param) {
      return _http.get(_api.sys.sysUserMine.opLoginSms, { params: param }).then(res => store.commit('SET_USER_INFO', res))
    },


    // 获取所属管理机构
    getSupervisorsTree(store) {
      return _http.get(_api.sys.sys.queryBranch, { params: { jsonConditions: { op: 'eq', param: 'id', values: 1 } } }).then(payload => store.commit('SET_BRANCH_TREE', payload.content[0]))
    },

    // 重置用户密码
    postSysUserRePass(store, params) {
      return _http.post(_api.sys.sysUserMine.opChangePass, params).then(payload => store.commit('SET_USER_INFO', payload))
    }


  }
})

export default store